import type { MixedItemDistResponse } from "@memorang/types";

const fetchCumulativeContentsDist = async (_bundleId: string) => {
	return {
		getMixedItemDistribution: {
			iconUrl: "",
			title: "",
			contents: [],
			freeTagIds: [],
			tags: [],
		} satisfies MixedItemDistResponse,
	};
};

export default fetchCumulativeContentsDist;
